/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Http service options
 */
export const httpOptions = {
  /**
   * Default `RequestInit` used for all http calls,
   *
   * @link [Request](https://developer.mozilla.org/en-US/docs/Web/API/Request/Request)
   */
  default: {
    cache: 'default',
    credentials: 'same-origin',
    method: 'GET',
    redirect: 'follow',
    headers: {
      'accept': 'application/json, text/html, text/plain',
      'x-requested-with': 'XMLHttpRequest',
    },
  },

  /**
   * Additional `RequestInit` used for http calls with `POST` method
   */
  post: {
    body: {},
    headers: {
      'content-type': 'application/json',
    },
  },

  /**
   * Additional `RequestInit` used for http calls with `PUT` method
   */
  put: {
    body: {},
    headers: {
      'content-type': 'application/json',
    },
  },

  /**
   * Additional `RequestInit` used for http calls with `PATCH` method
   */
  patch: {
    body: {},
    headers: {
      'content-type': 'application/json',
    },
  },
};
